// extracted by mini-css-extract-plugin
export var optionGrid = "_4s-7";
export var optionList = "_4s-6";
export var questionsBlock = "_4s-9";
export var spacer = "_4s-5";
export var stepCenteredContent = "_4s-3";
export var stepInner = "_4s-0";
export var stepInnerFullWidth = "_4s-1";
export var stepInnerLockScroll = "_4s-2";
export var stepTransitionFrame = "_4s-4";
export var welcomeBlock = "_4s-8";